// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.managed_layout__O\\+MXH {
  display: grid;
  gap: var(--space-6);
  grid-template-columns: minmax(0, 1fr);
}
.managed_upcoming__7UpGp {
  padding: var(--space-5);
  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);
  background: var(--kur-gold);
  color: #111;
}
.managed_upcomingLabel__qbgPN {
  margin: 0 0 var(--space-2);
  font-size: var(--text-eyebrow);
  letter-spacing: var(--tracking-eyebrow);
  text-transform: uppercase;
  font-weight: 700;
}
.managed_upcomingText__dhS6f {
  margin: 0;
  line-height: 1.55;
}
@media (min-width: 992px) {
  .managed_layout__O\\+MXH {
    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);
    gap: var(--space-8);
    align-items: start;
  }
  .managed_side__qehLd {
    position: sticky;
    top: 10rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/PAGES/PHYSICIANS/SECTIONS/MANAGED/managed.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,qCAAqC;AACvC;AACA;EACE,uBAAuB;EACvB,oDAAoD;EACpD,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,SAAS;EACT,iBAAiB;AACnB;AACA;EACE;IACE,wDAAwD;IACxD,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":[".layout {\n  display: grid;\n  gap: var(--space-6);\n  grid-template-columns: minmax(0, 1fr);\n}\n.upcoming {\n  padding: var(--space-5);\n  border-radius: 0 var(--radius-lg) 0 var(--radius-lg);\n  background: var(--kur-gold);\n  color: #111;\n}\n.upcomingLabel {\n  margin: 0 0 var(--space-2);\n  font-size: var(--text-eyebrow);\n  letter-spacing: var(--tracking-eyebrow);\n  text-transform: uppercase;\n  font-weight: 700;\n}\n.upcomingText {\n  margin: 0;\n  line-height: 1.55;\n}\n@media (min-width: 992px) {\n  .layout {\n    grid-template-columns: minmax(0, 0.8fr) minmax(0, 1.2fr);\n    gap: var(--space-8);\n    align-items: start;\n  }\n  .side {\n    position: sticky;\n    top: 10rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"layout": `managed_layout__O+MXH`,
	"upcoming": `managed_upcoming__7UpGp`,
	"upcomingLabel": `managed_upcomingLabel__qbgPN`,
	"upcomingText": `managed_upcomingText__dhS6f`,
	"side": `managed_side__qehLd`
};
export default ___CSS_LOADER_EXPORT___;
